module.exports = __webpack_public_path__ + "img/green_bell.6b2e849c.svg";